module.exports = __webpack_public_path__ + "img/icon_1_13.0e1045c0.png";